import { useEffect, useState } from "react"
import RadioBoxGroup from "../../radio-group/RadioGroup"
import InlineSetting from "../appearance/inline-setting/InlineSetting"
import Styles from "./DockSettings.module.scss"
import DropDown from "../../drop-down/DropDown"
import AppSlider from "../../app-slider/AppSlider"
import { RootStateOrAny, useDispatch,useSelector } from "react-redux"
import { disableAutoHideDock, enableAutoHideDock, moveDockToCenter, moveDockToLeft, moveDockToRight } from "../../../actions/dock"
import { handleDockVisibility } from "../../../reducers/dock"
import MainCheckBox from "../../maincheckbox/MainCheckBox"


const DockSettings = () => {

    const dispatch = useDispatch();

    const dockPosState= useSelector((state:RootStateOrAny)=>state.handleDockPosition)
    const autoHideDockState= useSelector((state:RootStateOrAny)=>state.handleDockVisibility)

    const [dockPosition, setDockPosition] = useState(dockPosState);
    const [windowCloseEffect, setWindowCloseEffect] = useState(0);
    const [autoHideDock, setAutoHideDock] = useState(autoHideDockState);
    const [dockSize, setDockSize] = useState(Number(document.documentElement.style.getPropertyValue(('--dock-size'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--dock-size'))) * 100 : 100);

    const [magnificationSize, setMagnificationSize] = useState(Number(document.documentElement.style.getPropertyValue(('--dock-app-magnification'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--dock-app-magnification'))) * 100 : 112.5);

    const dockPositionOptions = [
        {
            id: "left",
            label: "Left",
            value:"left",
            onClick:()=>{dispatch(moveDockToLeft())}
        },
        {
            id: "center",
            label: "Bottom",
            value:"center",
            onClick:()=>{dispatch(moveDockToCenter())}
        },
        {
            id: "right",
            label: "Right",
            value:"right",
            onClick:()=>{dispatch(moveDockToRight())}
        }
    ]


    const windowCloseEffectOptions = [
        {
            id: 0,
            label: "Genie Effect"
        },
    ]

    const handleDockSize = (value: number) => {
        setDockSize(value)
        document.documentElement.style.setProperty(('--dock-size'), String(value / 100))
    }

    const handleMagnificationSize = (value: number) => {
        setMagnificationSize(value)
        document.documentElement.style.setProperty(('--dock-app-magnification'), String(value / 100))
    }

    const onCLickDockVisibility=(state:boolean)=>{
        setAutoHideDock(state)
        if(state){
            dispatch(enableAutoHideDock())
        }
        else{
            dispatch(disableAutoHideDock())
        }
    }


    return (
        <div className={Styles.container}>

            <div className={Styles.full_flex} style={{ margin: "8px 0" }}>
                <div className={Styles.sliders}>
                    <AppSlider minLabel="small" maxLabel="large" minValue={100} maxValue={dockPosition==="center"?120:105} currentVal={dockSize} title={"Size :"} onChange={handleDockSize} />
                </div>
                <div className={Styles.sliders}>
                    <AppSlider minLabel="min" maxLabel="max" minValue={110} maxValue={125} currentVal={magnificationSize} title={"Magnification :"} onChange={handleMagnificationSize} />
                </div>
            </div>


            <div className={Styles.flex} style={{ margin: "4px 0" }}>
                <div className={Styles.label}>
                    Position On Screen :
                </div>
                <RadioBoxGroup selectedOption={dockPosition} handleChange={setDockPosition} options={dockPositionOptions} layout={"flex"} size={"small"} />
            </div>

            <div className={Styles.flex} style={{ margin: "4px 0" }}>
                <div className={Styles.label}>
                    Minimise window using :
                </div>
                <DropDown options={windowCloseEffectOptions} selected={windowCloseEffect} handleClick={setWindowCloseEffect} />
            </div>

            <div className={Styles.flex}>
                <MainCheckBox isChecked={false}  />
                <div className={Styles.label}>
                    Double Click a windows title bar to
                </div>
                <DropDown options={windowCloseEffectOptions} selected={windowCloseEffect} handleClick={setWindowCloseEffect} />
            </div>


            <div className={Styles.flex}>
                <MainCheckBox isChecked={false}  />
                <div className={Styles.label}>
                    Minimise Window into application icon
                </div>
            </div>

            <div className={Styles.flex}>
                <MainCheckBox isChecked={true}  />
                <div className={Styles.label}>
                    Animate opening application
                </div>
            </div>

            <div className={Styles.flex}>
                <MainCheckBox isChecked={false}  />
                <div className={Styles.label}>
                    Minimise Window into application icon
                </div>
            </div>


            <div className={Styles.flex}>
                <MainCheckBox isChecked={autoHideDock} onClick={onCLickDockVisibility} />
                <div className={Styles.label}>
                    Automatically show and hide the dock
                </div>
            </div>


            <div className={Styles.flex}>
                <MainCheckBox isChecked={false}  />
                <div className={Styles.label}>
                    Show indicators for open applications
                </div>
            </div>


            <div className={Styles.flex}>
                <MainCheckBox isChecked={false}  />
                <div className={Styles.label}>
                    Show recent applications in dock
                </div>
            </div>
        </div>
    )
}

export default DockSettings
